import React from 'react';
import Icon from '../AppIcon';

const SessionStatusIndicator = ({ 
  isOnline = false, 
  activeChats = 0, 
  activeVideoCalls = 0,
  onChatClick,
  onVideoClick 
}) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-2 px-3 py-2 bg-muted rounded-lg">
        <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-success' : 'bg-muted-foreground'}`} />
        <span className="text-sm font-medium text-muted-foreground">
          {isOnline ? 'Online' : 'Offline'}
        </span>
      </div>

      {activeChats > 0 && (
        <button
          onClick={onChatClick}
          className="flex items-center gap-2 px-3 py-2 bg-primary/10 hover:bg-primary/20 rounded-lg transition-smooth"
        >
          <Icon name="MessageSquare" size={16} color="var(--color-primary)" />
          <span className="text-sm font-medium text-primary data-text">
            {activeChats} {activeChats === 1 ? 'Chat' : 'Chats'}
          </span>
        </button>
      )}

      {activeVideoCalls > 0 && (
        <button
          onClick={onVideoClick}
          className="flex items-center gap-2 px-3 py-2 bg-accent/10 hover:bg-accent/20 rounded-lg transition-smooth animate-pulse"
        >
          <Icon name="Video" size={16} color="var(--color-accent)" />
          <span className="text-sm font-medium text-accent data-text">
            {activeVideoCalls} {activeVideoCalls === 1 ? 'Call' : 'Calls'}
          </span>
        </button>
      )}
    </div>
  );
};

export default SessionStatusIndicator;